import ModuleWrapper from 'shared-lib/containers/Module';

const KPIControl = () => import(/* webpackChunkName: "kpi-control" */ '@/views/kpiControl/KPIControl');

const meta = (data = {}) => ({
    privilegeModule: 'kpi_control',
    permission: 'read',
    auth: true,
    ...data,
});

export default [{
    path: 'kpi-control',
    component: ModuleWrapper,
    meta: meta({
        title: 'KPIControl',
    }),
    children: [
        {
            path: '',
            name: 'KPIControl',
            component: KPIControl,
            meta: meta(),
        },
    ],
}];
